import React, { useState } from 'react';
import events from "../../../../resources/event";
import { FilterType, IEventCardView } from "../../type/events.types";
import { getMonthFromRange, getNextMonth, getPreviousMonth } from "../../utils/utils";
import EmptyData from "../../../common/empty-data/empty-data";
import { CalendarOutlined } from "@ant-design/icons";
import EventViewModal from "./utils/event-view-modal";
import EventCardItem from "./utils/event-card-item";
import EventCardToolbar from "./utils/event-card-toolbar";
import "../../../../styles/component/event-cards.scss";

interface IState {
    eventFilter: FilterType,
    eventDetailModal: {
        open: boolean,
        data: any
    }
}

const EventCardView: React.FC<IEventCardView> = (props) => {



    const [state, setState] = useState<IState>({
        eventFilter: 'today',
        eventDetailModal: {
            open: false,
            data: {}
        }
    });


    function closeEventDetailModal() {
        setState({
            ...state,
            eventDetailModal: {
                open: false,
                data: {}
            }
        })
    }

    function openEventDetailModal(event: any) {
        setState({
            ...state,
            eventDetailModal: {
                open: true,
                data: event
            }
        })
    }


    const changeFilter = (filter: FilterType) => {
        setState(prev => ({...prev, eventFilter: filter}));
    };


    const visibleMonth = React.useMemo(
        () => getMonthFromRange(props.activeRange.start, props.activeRange.end).startDate,
        [props.activeRange.start, props.activeRange.end]
    );




    const filteredData = props.data[state.eventFilter];

    const handleNext = () => props.onMonthChange(getNextMonth(visibleMonth));

    const handlePrev = () => props.onMonthChange(getPreviousMonth(visibleMonth));


    return (
        <>
            <div className={'hrms-events__cards-wrapper'}>

                <EventCardToolbar
                    onNext={handleNext}
                    onPrev={handlePrev}
                    visibleMonth={visibleMonth}
                    filter={state.eventFilter}
                    onFilterChange={changeFilter}
                    onMonthChange={props.onMonthChange}
                />

                {filteredData.length === 0 ?
                    (
                        <EmptyData icon={<CalendarOutlined className={'calendar-empty-data-icon'}/>}
                                   title={"No Events Scheduled"}
                                   subtitle={"There are no events to display at the moment"}/>
                    ) :
                    (<div className={'hrms-events__cards-list'}>
                            {filteredData.map((item: any) => (
                                <EventCardItem
                                    key={item.id}
                                    item={item}
                                    onOpen={openEventDetailModal}
                                    isAdmin={props.isAdmin}

                                />
                            ))}
                        </div>
                    )}
            </div>

            <EventViewModal
                isAdmin={props.isAdmin}
                open={state.eventDetailModal.open}
                data={state.eventDetailModal.data}
                handleModalClose={closeEventDetailModal}
                handleDeleteEvent={props.handleDeleteEvent}
                openEditEventModal={props.openEditEventModal}
            />

        </>
    )
}

export default EventCardView;
